import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Button, Col } from 'react-bootstrap';
import * as moduleActions from 'redux/modules/modules';
import { isLoaded, load as loadmodules } from 'redux/modules/modules';
import { initializeWithKey } from 'redux-form';
import { ModuleForm } from 'components';
import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';
import { bindActionCreatorsSafe } from 'helpers/safeDispatch';
import { DeleteButton } from 'components';
import { translate } from 'react-i18next';

@translate(['common'])
@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLoaded(getState())) {
      return dispatch(loadmodules());
    }
  }
}])
@connect(
  state => ({
    modules: state.modules.data,
    editing: state.modules.editing,
    error: state.modules.error,
    loading: state.modules.loading
  }),
  bindActionCreatorsSafe({ ...moduleActions, initializeWithKey }))

export default class modules extends Component {


  render() {

    var self = this;

    const handleEdit = (module) => {
      const { editStart } = this.props; // eslint-disable-line no-shadow
      return () => editStart(String(module.id));
    };

    const handleDelete = (username) => {
      const { deleteModule } = this.props; // eslint-disable-line no-shadow
      return () => deleteModule(String(username));
    };

    const { modules, error, editing, loading, load, t } = this.props;

    let refreshClassName = 'fa fa-refresh';
    if (loading) {
      refreshClassName += ' fa-spin';
    }
    const styles = require('./Modules.scss');
    return (
      <div className={styles.modules + ' container'}>
        <h1>
          {t("main.modules")} &nbsp;
          <button className={styles.refreshBtn + ' btn btn-success'} onClick={load}>
            <i className={refreshClassName} /> {' '} {t("modules.reload_modules")}
          </button>
        </h1>
        <Helmet title="modules" />

        {error &&
          <div className="alert alert-danger" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"> </span>
            {t("main.connection_error")}
          </div>}
        {modules && modules.length &&

          <Col md={7}>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>{t("main.name")}</th>
                  <th>{t("main.action")}</th>
                </tr>
              </thead>
              <tbody>
                {
                  modules.map((module) => editing[module.id] ?
                    <ModuleForm formKey={String(module.id)} key={String(module.id)} initialValues={module} /> :
                    <tr key={module.id}>
                      <td className="col-md-3">{module.name}</td>
                      <td className="col-md-2" style={{ position: 'relative' }}>
                        <button className="btn btn-primary btn-sm" onClick={handleEdit(module)}>
                          <i className="fa fa-pencil" />
                        </button>
                        &nbsp;
      
                        <DeleteButton ctext={t("main.confirm")} isPromise={true} size="sm" callback={() => {
                          return new Promise((resolve, reject) => {
                            self.props.deleteModule(module.id).then(() => resolve(1));
                          })
                        }} />


                      </td>

                    </tr>)
                }
              </tbody>
            </table>
          </Col>}
      </div>
    );
  }
}

